import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../../bis-shared/src/lib/auth/auth.guard';
import { UnauthorizedComponent } from 'projects/bis-shared/src/lib/auth/unauthorized/unauthorized.component';
import { NotFoundComponent } from 'projects/bis-shared/src/lib/not-found/not-found/not-found.component';
import { AuthCallbackComponent } from 'projects/bis-shared/src/lib/auth/auth-callback/auth-callback.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LogoutComponent } from 'projects/bis-shared/src/lib/logout/logout.component';
import { LandingComponent } from './landing/landing.component';
import { MyGroupsComponent } from './my-groups/my-groups.component';
import { InvalidDomainComponent } from 'projects/bis-shared/src/lib/auth/invalid-domain/invalid-domain.component';
import { RecentDownloadsComponent } from './recent-downloads/recent-downloads/recent-downloads.component';
import { SsoComponent } from './sso/sso.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'webforms',
        loadChildren: () => import('./webforms/webforms.module').then(m => m.WebformsModule),
      },
      {
        path: 'document',
        loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
      },
      {
        path: 'third-party-administrator',
        loadChildren: () =>
          import('./third-party-administrator/third-party-administrator.module').then(
            m => m.ThirdPartyAdministratorModule,
          ),
      },
      {
        path: 'healthcare-provider',
        loadChildren: () =>
          import('./healthcare-provider/healthcare-provider.module').then(
            m => m.HealthcareProviderModule,
          ),
      },
      {
        path: 'medical-supplier',
        loadChildren: () =>
          import('./medical-supplier/medical-supplier.module').then(m => m.MedicalSupplierModule),
      },
      {
        path: 'user-profile',
        loadChildren: () =>
          import('./user-profile/user-profile.module').then(m => m.UserProfileModule),
      },
      {
        path: 'insurer',
        loadChildren: () => import('./insurer/insurer.module').then(m => m.InsurerModule),
      },
      {
        path: 'prior-authorization',
        loadChildren: () =>
          import('./prior-authorization/prior-authorization.module').then(
            m => m.PriorAuthorizationModule,
          ),
      },
      {
        path: 'my-groups',
        component: MyGroupsComponent,
      },
      {
        path: 'recent-downloads',
        component: RecentDownloadsComponent,
      },
      {
        path: '',
        component: DashboardComponent,
        data: {
          allowMobile: true,
        },
      },
    ],
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
    data: {
      allowAnonymous: true,
    },
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      allowAnonymous: true,
    },
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: {
      allowAnonymous: true,
    },
  },
  {
    path: 'invalid-domain',
    component: InvalidDomainComponent,
    data: {
      allowAnonymous: true,
    },
  },
  {
    path: 'sso',
    component: SsoComponent,
    data: {
      allowAnonymous: true,
    },
  },
  { path: '', component: LandingComponent },
  {
    path: 'login',
    component: LandingComponent,
    data: {
      allowAnonymous: true,
    },
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
